import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export type MappingSegmentationView = 'rate_code' | 'market_segment' | null;

export default class CentralMappingOrganizationSettingsModel extends Model {
  [Type] = 'central-mapping/organization-settings' as const;

  @attr('boolean')
  declare allowHotelAdminAndEditorsToEditMapping: boolean;

  @attr('string', { defaultValue: null })
  declare mappingSegmentationView: MappingSegmentationView;

  @attr('boolean')
  declare ratePlanFallbackEnabled: boolean;
}
